import { IWindowRuntimeConfig } from '@angle/types'

export const useRuntimeConfig = <T = IWindowRuntimeConfig>(): T => {
  if (typeof window !== 'undefined') {
    return (window as any).runtimeConfig
  }

  return undefined
}
